import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import ErrorBoundaryModal from "./ErrorBoundaryModal.jsx";
import { formatRouteError } from './errorBoundary.utils';
const RouteErrorFallback = () => {
  const routeError = useRouteError();
  const normalizedError = isRouteErrorResponse(routeError) ? {
    status: routeError.status,
    statusText: routeError.statusText,
    data: routeError.data
  } : routeError;
  const {
    message,
    details
  } = formatRouteError(normalizedError);
  return <ErrorBoundaryModal message={message} details={details} />;
};
export default RouteErrorFallback;